import { CompanyTypeEnum } from 'api';

import { formatCompanyType } from '../../utils/formatCompanyType/formatCompanyType';
import { SelectField, SelectFieldProps } from '../SelectField/SelectField';

const COMPANY_TYPE_ENUM_FALLBACK_VALUES = [
  'MRF',
  'PRF',
  'PL_RE',
  'MT_RE',
  'P_MRF',
  'PMILL',
  'PMERC',
  'BROKE',
  'MT_YD',
  'MT_SMELT',
  'OTHER',
  'EXCLUSIVE_REPRESENTATIVE',
] as CompanyTypeEnum[];

const COMPANY_TYPE_OPTIONS = (CompanyTypeEnum ? Object.values(CompanyTypeEnum) : COMPANY_TYPE_ENUM_FALLBACK_VALUES).map(
  (companyType: CompanyTypeEnum) => ({
    label: formatCompanyType(companyType),
    value: companyType,
  })
);

export const CompanyTypeSelectField = (props: Omit<SelectFieldProps, 'options'>) => {
  return <SelectField {...props} options={COMPANY_TYPE_OPTIONS} data-testid="company-type-select" />;
};
